<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('aboutus-main')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit About-Us</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <base-input
          alternative
          class="mb-3"
          name="Title"
          placeholder="Heading"
          :rules="{ required: true }"
          v-model="main_data.heading"
        >
        </base-input>
        <base-input
          alternative
          class="mb-3"
          name="link"
          :rules="{ required: true }"
          placeholder="Link"
          v-model="main_data.link"
        >
        </base-input>
        <quill-editor
          v-model="main_data.description"
          :options="editorOption"
          class="quill-h200px my-2"
        />

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      image: "",
      icon: "",
      coverImage: "",
      type: "",
      Ctags: [],
      editorOption: {
        theme: "snow",
      },
      typeOption: [
        {
          value: "main",
          label: "Main",
        },
        {
          value: "other",
          label: "Other",
        },
      ],
      pageData: {},
      main_data: {},
      imageErr: false,
      msg: {},
    };
  },
  computed: {
    ...mapState("mainAboutUs", {
      selectedContent: "selectedContent",
      ...mapState("auth", ["user"]),
    }),
  },
  watch: {
    pageData(val) {
      this.main_data = { ...val };
      // console.log(this.main_data);
    },
  },
  methods: {
    handleSuccess(image) {
      let mByte = 5 * 1048576;

      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },

    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let FormData = require("form-data");
      let data = new FormData();
      data.append("_id", this.main_data._id);
      data.append("heading", this.main_data.heading);
      data.append("description", this.main_data.description);
      data.append("link", this.main_data.link);
      data.append("_id", this.user._id);
      let loader = this.$loading();
      try {
        const editData = await this.$store.dispatch(
          "mainAboutUs/update_aboutUs",
          data
        );
        // if (editData.code == 200) {
        this.$router.push({ name: "aboutus-main" });
        this.$swal.fire({
          text: "Your content has been successfully edited",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        // }
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async init() {
      this.pageData = this.selectedContent;
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.h300px {
  height: 300px !important;
}
.imgupload {
  height: 270px !important;
}
</style>
